const appName = process.env.REACT_APP_APP_NAME;

const buildRoute = (path) => {
    return appName ?  `/${appName}${path}` : `${path}`;
};

module.exports = {
    buildRoute
}